import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, Button, HStack, useMultiStyleConfig, useMediaQuery} from '@chakra-ui/react'
import CustomLink from '../../../custom-link'
import {TextTitleDescription} from '../../text-title-description'
import {remCalc} from '../../../../theme/_utils'
import {ChevronRight} from '../../../icons/arrows'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {safeBuildUrl, getGlobalLink} from '../../../../utils/contentstack-utils'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const MoodBoardCard = ({textBlock, images, cta}) => {
    const categoryData = useGetCategoriesData()
    const {buildUrl} = useMultiSite()

    const {url, label, isAbsolute} = getGlobalLink(cta, categoryData)
    const [isSmallTablet] = useMediaQuery(
        `(min-width: ${remCalc(450)}) and (max-width: ${remCalc(768)})`,
    )

    const styles = useMultiStyleConfig('Moodboard', {
        isSmallTablet,
    })

    const damImage = useDamImage(images)

    return (
        <CustomLink
            isExternal={isAbsolute}
            href={isAbsolute ? url : safeBuildUrl(url, buildUrl)}
            _hover={{textDecoration: 'none'}}
            data-testid="moodboard-card-link"
        >
            <Flex
                backgroundImage={
                    damImage.url
                        ? `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%), url(${damImage.url})`
                        : 'none'
                }
                {...styles.cardContainer}
                data-testid="moodboard-container"
            >
                <Flex {...styles.textContentContainer} data-testid="moodboard-text-container">
                    <TextTitleDescription
                        title={textBlock?.title}
                        mb={{base: remCalc(16), md: remCalc(16), lg: remCalc(16), xl: remCalc(24)}}
                        titleSpacing={{
                            base: remCalc(16),
                            md: remCalc(16),
                            lg: remCalc(16),
                            xl: remCalc(24),
                        }}
                        textStyle="head-small"
                        color="text.inverse"
                        weight="500"
                        childrenTextStyle="body-medium"
                        childrenTextColor="text.inverse"
                        maxWidth={remCalc(266)}
                    >
                        {textBlock?.body_copy}
                    </TextTitleDescription>
                    {label && (
                        <Button variant="inverse" aria-label={label} tabIndex={0}>
                            <HStack gap={remCalc(10)} textDecoration={'none'}>
                                <Text as="span" color="text.inverse" fontStyle="body-medium">
                                    {label}
                                </Text>
                                <ChevronRight
                                    aria-label="right icon"
                                    backgroundColor="background.default"
                                    borderRadius="50%"
                                />
                            </HStack>
                        </Button>
                    )}
                </Flex>
            </Flex>
        </CustomLink>
    )
}

MoodBoardCard.propTypes = {
    textBlock: PropTypes.shape({
        title: PropTypes.string,
        body_copy: PropTypes.string,
    }),
    images: PropTypes.object,
    cta: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
}

export default MoodBoardCard
